import { Club } from "../../types/club/Club";
import { Facility } from "../../types/Facility";
import { TrainingGroup } from "../../types/training-group/TrainingGroup";
import { SportAssociationNumberOf } from "../../types/SportAssociation";

export type SingleTGResponse = {
  trainingGroup?: TrainingGroup;
  club?: Club;
  facilities?: Facility[];
};

export const fetchTrainingGroup = async (
  backendUrl: string,
  id: string,
  sportAssociation: string,
): Promise<SingleTGResponse> => {
  const response = await fetch(backendUrl + "/training-group/" + id, {
    headers: {
      "Content-Type": "application/json",
      "X-Sport-Association": SportAssociationNumberOf(sportAssociation),
    },
  });
  const data = await response.json();
  return data;
};
